/**
 * @Author: Tom Voorneveld <tom>
 * @Date:   2019-02-19T15:42:33+01:00
 * @Email:  tom@lorinthe.com
 * @Project: Lorinthe
  @Last modified by:   tom
  @Last modified time: 2019-06-13T00:16:52+02:00
 * @Copyright: (c) copyright Lorinthe BV, all rights reserved
 */

/* eslint-disable no-console */

import { register } from 'register-service-worker'
import Log from '@/lib/log'

if (process.env.NODE_ENV === 'production') {
  Log.i('Service worker registration starting...')
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      Log.i(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      Log.i('Service worker has been registered.')
    },
    cached () {
      Log.i('Content has been cached for offline use.')
    },
    updatefound () {
      Log.i('New content is downloading.')
    },
    updated () {
      Log.i('New content is available; please refresh.')
      // added https://stackoverflow.com/questions/54145735/vue-pwa-not-getting-new-content-after-refresh
      // window.location.reload(true)
    },
    offline () {
      Log.i('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      Log.e('Error during service worker registration:', error)
    }
  })

  // @TODO: By TVld, does not work ???
  // Listen for claiming of our ServiceWorker
  // And then reload automatically
  // navigator.serviceWorker.addEventListener('controllerchange', function () {
  //   Log.i('Service worker status changed: ', this.controller.state)
  //   // Listen for changes in the state of our ServiceWorker
  //   navigator.serviceWorker.controller.addEventListener('statechange', function () {
  //     // If the ServiceWorker becomes "activated", let the user know they can go offline!
  //     if (this.state === 'activated') {
  //       window.location.reload(true)
  //     }
  //   })
  // })
}
